// extracted by mini-css-extract-plugin
module.exports = {"brafEditor":"index_brafEditor__MeYEj"};